export default __webpack_public_path__ + "static/media/newarrival2.ac492861.png";